import React from "react"
import type { ComparisonRow } from "../../data/types"

type ComparisonTableProps = {
  rows: ComparisonRow[]
  aLabel: string
  bLabel: string
}

export const ComparisonTable = ({
  rows,
  aLabel,
  bLabel,
}: ComparisonTableProps) => (
  <section className="text-gray-700 body-font">
    <div className="container mx-auto px-5 py-10">
      <div className="max-w-3xl overflow-x-auto">
        <table className="w-full border-collapse text-left">
          <thead>
            <tr className="border-b-2 border-purple-200">
              <th className="py-3 pr-4 text-sm uppercase tracking-wider text-gray-500"></th>
              <th className="py-3 px-4 text-sm uppercase tracking-wider text-purple-600">
                {aLabel}
              </th>
              <th className="py-3 px-4 text-sm uppercase tracking-wider text-purple-600">
                {bLabel}
              </th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, idx) => (
              <tr key={idx} className="border-b border-gray-100">
                <td className="py-3 pr-4 font-medium text-gray-900 align-top">
                  {row.attribute}
                </td>
                <td className="py-3 px-4 align-top">{row.a}</td>
                <td className="py-3 px-4 align-top">{row.b}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </section>
)
